import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { ContentSharingPermissionFragmentDoc } from '../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TrainingResourceSharingPermissionsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type TrainingResourceSharingPermissionsQuery = { __typename?: 'Query', TrainingResource?: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, sharingPermissions: { __typename?: 'ContentSharingPermission', id: string, allAdmins: Types.SharingPermission, allManagers: Types.SharingPermission, individuals: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } }> }, createdBy?: { __typename?: 'Employee', id: number } | null } } | null };

export type TrainingResourceSharingPermissionsTrainingResourceFragment = { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, sharingPermissions: { __typename?: 'ContentSharingPermission', id: string, allAdmins: Types.SharingPermission, allManagers: Types.SharingPermission, individuals: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } }> }, createdBy?: { __typename?: 'Employee', id: number } | null } };

export const TrainingResourceSharingPermissionsTrainingResourceFragmentDoc = gql`
    fragment TrainingResourceSharingPermissionsTrainingResource on TrainingResource {
  id
  libraryItem {
    id
    sharingPermissions {
      ...ContentSharingPermission
    }
    createdBy {
      id
    }
  }
}
    ${ContentSharingPermissionFragmentDoc}`;
export const TrainingResourceSharingPermissionsDocument = gql`
    query TrainingResourceSharingPermissions($id: String!) {
  TrainingResource: AdminTrainingResource(id: $id) {
    ...TrainingResourceSharingPermissionsTrainingResource
  }
}
    ${TrainingResourceSharingPermissionsTrainingResourceFragmentDoc}`;

/**
 * __useTrainingResourceSharingPermissionsQuery__
 *
 * To run a query within a React component, call `useTrainingResourceSharingPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingResourceSharingPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingResourceSharingPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainingResourceSharingPermissionsQuery(baseOptions: Apollo.QueryHookOptions<TrainingResourceSharingPermissionsQuery, TrainingResourceSharingPermissionsQueryVariables> & ({ variables: TrainingResourceSharingPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingResourceSharingPermissionsQuery, TrainingResourceSharingPermissionsQueryVariables>(TrainingResourceSharingPermissionsDocument, options);
      }
export function useTrainingResourceSharingPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingResourceSharingPermissionsQuery, TrainingResourceSharingPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingResourceSharingPermissionsQuery, TrainingResourceSharingPermissionsQueryVariables>(TrainingResourceSharingPermissionsDocument, options);
        }
export type TrainingResourceSharingPermissionsQueryHookResult = ReturnType<typeof useTrainingResourceSharingPermissionsQuery>;
export type TrainingResourceSharingPermissionsLazyQueryHookResult = ReturnType<typeof useTrainingResourceSharingPermissionsLazyQuery>;
export type TrainingResourceSharingPermissionsQueryResult = Apollo.QueryResult<TrainingResourceSharingPermissionsQuery, TrainingResourceSharingPermissionsQueryVariables>;